import { gameStorage as localStorage } from "./gameIdentity.js";
const ACCOUNT_XP_KEY = "pureconvo_account_xp";
const LEGACY_XP_KEY = "pureconvo_xp";
const DIALECT_XP_KEY = "pureconvo_xp_dict";
const MIGRATION_KEY = "pureconvo_xp_recovery_v2";

const toXp = (value) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

const readDialectXpMap = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem(DIALECT_XP_KEY) || "{}");
        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
        return Object.fromEntries(
            Object.entries(parsed).map(([dialect, value]) => [dialect, toXp(value)])
        );
    } catch {
        return {};
    }
};

const writeDialectXpMap = (xpByDialect) => {
    localStorage.setItem(DIALECT_XP_KEY, JSON.stringify(xpByDialect));
};

export const persistAccountXp = (value) => {
    const accountXp = toXp(value);
    localStorage.setItem(ACCOUNT_XP_KEY, String(accountXp));
    localStorage.setItem(LEGACY_XP_KEY, String(accountXp));
    return accountXp;
};

export const recoverAccountXp = () => {
    const savedAccountXp = toXp(localStorage.getItem(ACCOUNT_XP_KEY));
    const legacyXp = toXp(localStorage.getItem(LEGACY_XP_KEY));
    const dialectXp = readDialectXpMap();
    const dialectXpTotal = Object.values(dialectXp).reduce((total, value) => total + toXp(value), 0);
    const recoveredAccountXp = Math.max(savedAccountXp, legacyXp, dialectXpTotal);

    persistAccountXp(recoveredAccountXp);
    if (!localStorage.getItem(MIGRATION_KEY)) {
        localStorage.setItem(MIGRATION_KEY, JSON.stringify({
            version: 2,
            recovered_at: new Date().toISOString(),
            saved_account_xp: savedAccountXp,
            legacy_xp: legacyXp,
            dialect_xp_total: dialectXpTotal,
            recovered_account_xp: recoveredAccountXp,
        }));
    }
    return recoveredAccountXp;
};

export const getDialectXp = (dialect) => {
    if (!dialect) return 0;
    return toXp(readDialectXpMap()[dialect]);
};

export const mergeDialectXp = (setAccountXp, dialect, remoteValue) => {
    if (!dialect) return 0;
    const xpByDialect = readDialectXpMap();
    const previousDialectXp = toXp(xpByDialect[dialect]);
    const mergedDialectXp = Math.max(previousDialectXp, toXp(remoteValue));
    xpByDialect[dialect] = mergedDialectXp;
    writeDialectXpMap(xpByDialect);

    const recoveredDelta = mergedDialectXp - previousDialectXp;
    if (recoveredDelta > 0 && typeof setAccountXp === "function") {
        setAccountXp((current) => persistAccountXp(toXp(current) + recoveredDelta));
    }
    return mergedDialectXp;
};

export const awardAccountXp = (setAccountXp, amount, dialect = "") => {
    const award = toXp(amount);
    if (!award) return;

    if (dialect) {
        const xpByDialect = readDialectXpMap();
        xpByDialect[dialect] = toXp(xpByDialect[dialect]) + award;
        writeDialectXpMap(xpByDialect);
    }

    if (typeof setAccountXp === "function") {
        setAccountXp((current) => persistAccountXp(toXp(current) + award));
    }
};
